import { Link } from "react-router-dom";
import type { Article } from "@/mocks/articles";
import ArticleCard from "@/components/feature/ArticleCard";

interface HotArticlesProps {
  articles: Article[];
}

export default function HotArticles({ articles }: HotArticlesProps) {
  const hotArticles = articles.filter((a) => a.isHot).slice(0, 6);
  const latestArticles = articles.slice(0, 6);

  return (
    <section className="py-8 md:py-10" aria-label="热门文章">
      <div className="flex items-center justify-between mb-5">
        <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-100">
          <i className="ri-fire-line text-primary-500 mr-2"></i>
          热门爆料
        </h3>
        <Link to="/category/mingxing-heiliao" className="text-sm text-primary-400 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap">
          查看全部 <i className="ri-arrow-right-line ml-1"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {hotArticles.map((article) => (
          <ArticleCard key={article.id} article={article} variant="default" />
        ))}
      </div>

      <div className="mt-10">
        <div className="flex items-center justify-between mb-5">
          <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-100">
            <i className="ri-time-line text-accent-500 mr-2"></i>
            最新爆料
          </h3>
          <Link to="/category/lianqing-baoguang" className="text-sm text-primary-400 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap">
            查看全部 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {latestArticles.map((article) => (
            <ArticleCard key={article.id} article={article} variant="default" />
          ))}
        </div>
      </div>
    </section>
  );
}